<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { setmeta } from '@/assets/js/setmeta'
export default {
  name: 'App',
  mixins: [setmeta],
  created () {
    this.getSystemConfig()
  }
}
</script>

<style lang="scss">
@import './assets/scss/base.scss';
@import './assets/scss/common.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue